export default {
    zh: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI 视频生成器 - Pikaframes关键帧控制、10秒1080p高清视频',
        pageDescription: '体验 Pika Labs 最新力作 Pika 2.2，引入革命性 Pikaframes 关键帧控制技术，支持长达 10 秒 1080p 高清视频生成。在 WeryAI 立即体验。',
        pageKeywords: 'Pika 2.2, Pikaframes, 关键帧控制, AI视频生成器, 1080p, Pikaffects, 文生视频, 图生视频, WeryAI',

        // 生成器部分
        generatorTitle: 'Pika AI 视频生成器（Pika Labs）',
        generatorDescription: 'WeryAI 现已深度集成Pika 2.2模型，引入革命性的 Pikaframes（关键帧控制）技术，支持长达 10 秒的 1080p 高清视频生成。无论你是想实现丝滑的形态变换，还是制作脑洞大开的物理特效，Pika 2.2 都能让你的创意在指尖流动，精准可控。在 WeryAI 立即体验 Pika 2.2。',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Pika 2.2 核心功能',

        // 功能特点
        feature1Title: 'Pikaframes 关键帧控制：掌控时空的魔法',
        feature1Description: '这是 Pika 2.2 最具颠覆性的更新！你现在可以上传起始帧和结束帧，AI 将智能计算并生成两者之间丝滑的过渡动画。不再是不可控的随机变形，你可以精准导演"从鸡蛋孵化成鸟"、"从素描变实景"或"人物换装"的每一个瞬间。',
        feature2Title: '10 秒长视频生成，叙事更完整',
        feature2Description: '告别短促的 3 秒片段。Pika 2.2 将视频生成时长上限翻倍至 10 秒。这意味着你可以用一个镜头讲述一个完整的小故事，展现更丰富的角色表演、更复杂的运镜轨迹，为短视频创作提供更多可能。',
        feature3Title: 'Pikaffects 创意物理特效：万物皆可"玩"',
        feature3Description: 'Pika 经典的物理特效在 2.2 版本中更加逼真。只需一个指令，即可让视频中的物体违反物理定律，产生令人惊叹的视觉奇观。支持 Melt (融化)、Crush (压扁)、Inflate (充气)、Cake-ify (变蛋糕) 等多种脑洞玩法。',
        feature4Title: '1080p 电影级画质，细节分毫毕现',
        feature4Description: '模糊不再是 AI 视频的代名词。Pika 2.2 原生支持 1080p 高清分辨率，无论是人物的发丝、衣物的纹理，还是光影的微妙变化，都清晰锐利，直接达到社交媒体发布的成品标准。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择 Pika 2.2 模型',
        step1Description: '前往"AI视频生成"页面，在模型下拉菜单中选择"Pika 2.2"。',
        step2Title: '输入您的创意',
        step2Description: '输入文字描述，或上传图片作为视频生成的参考素材。支持 Pikaframes 双图上传。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，等待视频生成完成后即可下载或分享。',

        // YouTube 视频部分
        youtubeTitle: '关于 Pika 2.2 的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Pika 2.2 的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        seedanceTitle: 'Seedance 1.0 Pro AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI 视频生成器',
        runwayTitle: 'Runway AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Pika 2.2，将您的创意转化为精彩视频',
        ctaButton: '开始创作',
        ctaDisclaimer: '无需信用卡 · 新用户免费体验',
    },
    en: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI Video Generator - Pikaframes Keyframe Control, 10-Second 1080p HD Videos',
        pageDescription: 'Experience Pika Labs\' latest Pika 2.2 with revolutionary Pikaframes keyframe control technology, supporting up to 10-second 1080p HD video generation. Try now on WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, keyframe control, AI video generator, 1080p, Pikaffects, text to video, image to video, WeryAI',

        // Generator section
        generatorTitle: 'Pika AI Video Generator (Pika Labs)',
        generatorDescription: 'WeryAI now deeply integrates the Pika 2.2 model, Introducing revolutionary Pikaframes (keyframe control) technology, supporting up to 10-second 1080p HD video generation. Whether you want to achieve smooth morphing transitions or create mind-bending physics effects, Pika 2.2 lets your creativity flow at your fingertips with precise control. Experience Pika 2.2 now on WeryAI.',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Pika 2.2 Core Features',

        // Features
        feature1Title: 'Pikaframes Keyframe Control: Mastering Time and Space',
        feature1Description: 'This is Pika 2.2\'s most disruptive update! You can now upload start and end frames, and AI will intelligently calculate and generate smooth transition animations between them. No more uncontrollable random morphing—you can precisely direct every moment of "egg hatching into bird", "sketch to reality", or "character costume change".',
        feature2Title: '10-Second Long Video Generation for Complete Storytelling',
        feature2Description: 'Say goodbye to brief 3-second clips. Pika 2.2 doubles the video generation limit to 10 seconds. This means you can tell a complete mini-story in one shot, showcase richer character performances, more complex camera movements, and unlock more possibilities for short video creation.',
        feature3Title: 'Pikaffects Creative Physics Effects: Everything is Playable',
        feature3Description: 'Pika\'s classic physics effects are even more realistic in version 2.2. With just one command, you can make objects in your video defy physics laws and create stunning visual spectacles. Supports Melt, Crush, Inflate, Cake-ify, and many other creative effects.',
        feature4Title: '1080p Cinema-Quality Visuals with Crystal-Clear Details',
        feature4Description: 'Blur is no longer synonymous with AI video. Pika 2.2 natively supports 1080p HD resolution—whether it\'s hair strands, fabric textures, or subtle light variations, everything is crisp and sharp, meeting social media publication standards right out of the box.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Pika 2.2 Model',
        step1Description: 'Go to the "AI Video Generation" page and select "Pika 2.2" from the model dropdown menu.',
        step2Title: 'Input Your Creative Ideas',
        step2Description: 'Enter a text description, or upload images as reference materials. Supports Pikaframes dual-image upload.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" and download or share once the video generation is complete.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Pika 2.2',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Pika 2.2',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        seedanceTitle: 'Seedance 1.0 Pro AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Pika 2.2 now and transform your creativity into amazing videos',
        ctaButton: 'Start Creating',
        ctaDisclaimer: 'No credit card required · Free trial for new users',
    },
    ja: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI動画ジェネレーター - Pikaframesキーフレーム制御、10秒1080p HD動画',
        pageDescription: 'Pika Labsの最新作Pika 2.2を体験。革命的なPikaframesキーフレーム制御技術で、最大10秒の1080p HD動画生成に対応。WeryAIで今すぐ体験。',
        pageKeywords: 'Pika 2.2, Pikaframes, キーフレーム制御, AI動画ジェネレーター, 1080p, Pikaffects, テキストから動画, 画像から動画, WeryAI',

        // Generator section
        generatorTitle: 'Pika AI動画ジェネレーター（Pika Labs）',
        generatorDescription: 'WeryAI はPika 2.2モデルを深く統合し、革命的なPikaframes（キーフレーム制御）技術を導入し、最大10秒の1080p HD動画生成に対応。滑らかなモーフィング変換でも、驚異的な物理エフェクトでも、Pika 2.2があなたの創造性を指先で正確にコントロール。WeryAIで今すぐPika 2.2を体験。',

        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',
        coreFeaturesTitle: 'Pika 2.2 コア機能',
        feature1Title: 'Pikaframesキーフレーム制御：時空を操る魔法',
        feature1Description: 'これはPika 2.2最大の革新的アップデート！開始フレームと終了フレームをアップロードでき、AIが両者間の滑らかなトランジションアニメーションを自動生成。もう制御不能なランダム変形ではありません。「卵から鳥への孵化」「スケッチから実写へ」「キャラクターの衣装チェンジ」のすべての瞬間を精密に演出できます。',
        feature2Title: '10秒ロング動画生成で完全なストーリーテリング',
        feature2Description: '短い3秒クリップとはお別れ。Pika 2.2は動画生成の上限を10秒に倍増。一つのショットで完全なミニストーリーを語り、より豊かなキャラクター演技、より複雑なカメラワークを実現し、ショート動画制作の可能性を広げます。',
        feature3Title: 'Pikaffectsクリエイティブ物理エフェクト：すべてが遊べる',
        feature3Description: 'Pikaの定番物理エフェクトがバージョン2.2でさらにリアルに。コマンド一つで動画内のオブジェクトに物理法則を無視させ、驚異的な視覚スペクタクルを創造。Melt（溶解）、Crush（圧縮）、Inflate（膨張）、Cake-ify（ケーキ化）など多彩なエフェクトに対応。',
        feature4Title: '1080pシネマクオリティ、細部まで鮮明',
        feature4Description: 'ぼやけはもはやAI動画の代名詞ではありません。Pika 2.2は1080p HD解像度をネイティブサポート。髪の毛、布地のテクスチャ、微妙な光の変化まで、すべてがクリアでシャープ。SNS投稿基準をそのまま満たします。',
        howToUseTitle: '使い方',
        step1Title: 'Pika 2.2モデルを選択',
        step1Description: '「AI動画生成」ページに移動し、モデルドロップダウンメニューから「Pika 2.2」を選択します。',
        step2Title: 'クリエイティブなアイデアを入力',
        step2Description: 'テキスト説明を入力するか、参照素材として画像をアップロード。Pikaframesデュアル画像アップロードに対応。',
        step3Title: '動画をダウンロード',
        step3Description: '「作成」をクリックし、動画生成が完了したらダウンロードまたは共有します。',
        youtubeTitle: 'Pika 2.2についてのYouTube動画',
        xPostsTitle: 'Pika 2.2についての人気X投稿',
        exploreModelsTitle: 'Explore Other Models',
        seedanceTitle: 'Seedance 1.0 Pro AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        faqTitle: 'よくある質問',
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐPika 2.2を体験し、あなたのクリエイティビティを素晴らしい動画に変換',
        ctaButton: '創作を開始',
        ctaDisclaimer: 'クレジットカード不要 · 新規ユーザー無料体験',
    },
    ko: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI 비디오 생성기 - Pikaframes 키프레임 제어, 10초 1080p HD 비디오',
        pageDescription: 'Pika Labs의 최신작 Pika 2.2를 체험하세요. 혁신적인 Pikaframes 키프레임 제어 기술로 최대 10초 1080p HD 비디오 생성을 지원합니다. WeryAI에서 지금 체험하세요.',
        pageKeywords: 'Pika 2.2, Pikaframes, 키프레임 제어, AI 비디오 생성기, 1080p, Pikaffects, 텍스트를 비디오로, 이미지를 비디오로, WeryAI',

        generatorTitle: 'Pika AI 비디오 생성기 (Pika Labs)',
        generatorDescription: 'WeryAI는 이제 Pika 2.2 모델을 심층 통합하여, 혁신적인 Pikaframes(키프레임 제어) 기술을 도입하여 최대 10초 1080p HD 비디오 생성을 지원합니다. 부드러운 모핑 전환이든 놀라운 물리 효과든, Pika 2.2로 창의력을 손끝에서 정밀하게 제어하세요. WeryAI에서 지금 Pika 2.2를 체험하세요.',

        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',
        coreFeaturesTitle: 'Pika 2.2 핵심 기능',
        feature1Title: 'Pikaframes 키프레임 제어: 시공간을 지배하는 마법',
        feature1Description: 'Pika 2.2의 가장 혁신적인 업데이트입니다! 시작 프레임과 끝 프레임을 업로드하면 AI가 둘 사이의 부드러운 전환 애니메이션을 자동으로 생성합니다. 더 이상 제어 불가능한 랜덤 변형이 아닙니다. "달걀에서 새로 부화", "스케치에서 실사로", "캐릭터 의상 변경"의 모든 순간을 정밀하게 연출할 수 있습니다.',
        feature2Title: '10초 롱 비디오 생성으로 완전한 스토리텔링',
        feature2Description: '짧은 3초 클립과 작별하세요. Pika 2.2는 비디오 생성 한계를 10초로 두 배 늘렸습니다. 하나의 샷으로 완전한 미니 스토리를 전달하고, 더 풍부한 캐릭터 연기, 더 복잡한 카메라 움직임을 보여주며, 숏폼 비디오 제작의 가능성을 열어줍니다.',
        feature3Title: 'Pikaffects 크리에이티브 물리 효과: 모든 것이 플레이 가능',
        feature3Description: 'Pika의 클래식 물리 효과가 버전 2.2에서 더욱 사실적으로 진화했습니다. 단 하나의 명령으로 비디오 속 물체가 물리 법칙을 무시하게 하여 놀라운 시각적 스펙터클을 만들어보세요. Melt(녹이기), Crush(압축), Inflate(부풀리기), Cake-ify(케이크화) 등 다양한 효과를 지원합니다.',
        feature4Title: '1080p 시네마 품질의 선명한 디테일',
        feature4Description: '흐림은 더 이상 AI 비디오의 대명사가 아닙니다. Pika 2.2는 1080p HD 해상도를 네이티브로 지원합니다. 머리카락, 직물 텍스처, 미묘한 빛의 변화까지 모두 선명하고 날카롭게, 소셜 미디어 게시 기준을 바로 충족합니다.',
        howToUseTitle: '사용 방법',
        step1Title: 'Pika 2.2 모델 선택',
        step1Description: '"AI 비디오 생성" 페이지로 이동하여 모델 드롭다운 메뉴에서 "Pika 2.2"를 선택합니다.',
        step2Title: '창의적인 아이디어 입력',
        step2Description: '텍스트 설명을 입력하거나 참조 자료로 이미지를 업로드합니다. Pikaframes 듀얼 이미지 업로드를 지원합니다.',
        step3Title: '비디오 다운로드',
        step3Description: '"만들기"를 클릭하고 비디오 생성이 완료되면 다운로드하거나 공유합니다.',
        youtubeTitle: 'Pika 2.2에 대한 YouTube 비디오',
        xPostsTitle: 'Pika 2.2에 대한 인기 X 게시물',
        exploreModelsTitle: 'Explore Other Models',
        seedanceTitle: 'Seedance 1.0 Pro AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        faqTitle: '자주 묻는 질문',
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Pika 2.2를 체험하고 당신의 창의력을 놀라운 비디오로 변환하세요',
        ctaButton: '창작 시작',
        ctaDisclaimer: '신용카드 불필요 · 신규 사용자 무료 체험',
    },
    tw: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI 影片產生器 - Pikaframes 關鍵影格控制、10 秒 1080p 高畫質影片',
        pageDescription: '體驗 Pika Labs 最新力作 Pika 2.2，引入革命性 Pikaframes 關鍵影格控制技術，支援長達 10 秒 1080p 高畫質影片生成。在 WeryAI 立即體驗。',
        pageKeywords: 'Pika 2.2, Pikaframes, 關鍵影格控制, AI 影片產生器, 1080p, Pikaffects, 文生影片, 圖生影片, WeryAI',

        // 生成器部分
        generatorTitle: 'Pika AI 影片產生器（Pika Labs）',
        generatorDescription: 'WeryAI 現已深度整合Pika 2.2模型，引入革命性的 Pikaframes（關鍵影格控制）技術，支援長達 10 秒的 1080p 高畫質影片生成。無論你是想實現絲滑的形態變換，還是製作腦洞大開的物理特效，Pika 2.2 都能讓你的創意在指尖流動，精準可控。在 WeryAI 立即體驗 Pika 2.2。',

        // 標籤頁
        tabImageToVideo: '圖生影片',
        tabTextToVideo: '文生影片',

        // 核心功能部分
        coreFeaturesTitle: 'Pika 2.2 核心功能',

        // 功能特點
        feature1Title: 'Pikaframes 關鍵影格控制：掌控時空的魔法',
        feature1Description: '這是 Pika 2.2 最具顛覆性的更新！你現在可以上傳起始影格和結束影格，AI 將智慧計算並生成兩者之間絲滑的過渡動畫。不再是不可控的隨機變形，你可以精準導演「從雞蛋孵化成鳥」、「從素描變實景」或「人物換裝」的每一個瞬間。',
        feature2Title: '10 秒長影片生成，敘事更完整',
        feature2Description: '告別短促的 3 秒片段。Pika 2.2 將影片生成時長上限翻倍至 10 秒。這意味著你可以用一個鏡頭講述一個完整的小故事，展現更豐富的角色表演、更複雜的運鏡軌跡，為短影片創作提供更多可能。',
        feature3Title: 'Pikaffects 創意物理特效：萬物皆可「玩」',
        feature3Description: 'Pika 經典的物理特效在 2.2 版本中更加逼真。只需一個指令，即可讓影片中的物體違反物理定律，產生令人驚嘆的視覺奇觀。支援 Melt (融化)、Crush (壓扁)、Inflate (充氣)、Cake-ify (變蛋糕) 等多種腦洞玩法。',
        feature4Title: '1080p 電影級畫質，細節分毫畢現',
        feature4Description: '模糊不再是 AI 影片的代名詞。Pika 2.2 原生支援 1080p 高畫質解析度，無論是人物的髮絲、衣物的紋理，還是光影的微妙變化，都清晰銳利，直接達到社群媒體發佈的成品標準。',

        // 如何使用部分
        howToUseTitle: '使用方法',
        step1Title: '選擇 Pika 2.2 模型',
        step1Description: '前往「AI 影片生成」頁面，在模型下拉選單中選擇「Pika 2.2」。',
        step2Title: '輸入您的創意',
        step2Description: '輸入文字描述，或上傳圖片作為影片生成的參考素材。支援 Pikaframes 雙圖上傳。',
        step3Title: '下載您的影片',
        step3Description: '點擊「建立」，等待影片生成完成後即可下載或分享。',

        // YouTube 影片部分
        youtubeTitle: '關於 Pika 2.2 的 YouTube 影片',

        // X Posts 部分
        xPostsTitle: '關於 Pika 2.2 的熱門 X 貼文',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        seedanceTitle: 'Seedance 1.0 Pro AI 影片產生器',
        sora2Title: 'OpenAI Sora-2 AI 影片產生器',
        runwayTitle: 'Runway AI 影片產生器',

        // FAQ 部分
        faqTitle: '常見問題解答',

        // CTA 部分
        ctaTitle: '準備開始創作了嗎？',
        ctaDescription: '立即體驗 Pika 2.2，將您的創意轉化為精彩影片',
        ctaButton: '開始創作',
        ctaDisclaimer: '無需信用卡 · 新使用者免費體驗',
    },
    pl: {
        // SEO Meta
        pageTitle: 'Generator wideo AI Pika 2.2 - sterowanie klatkami kluczowymi Pikaframes, 10-sekundowe filmy 1080p HD',
        pageDescription: 'Poznaj najnowsze dzieło Pika Labs - Pika 2.2 z rewolucyjną technologią sterowania klatkami kluczowymi Pikaframes, obsługującą generowanie wideo 1080p HD o długości do 10 sekund. Wypróbuj teraz w WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, sterowanie klatkami kluczowymi, generator wideo AI, 1080p, Pikaffects, tekst na wideo, obraz na wideo, WeryAI',

        // Generator section
        generatorTitle: 'Generator wideo AI Pika (Pika Labs)',
        generatorDescription: 'WeryAI jest teraz głęboko zintegrowane z modelem Pika 2.2, Wprowadza rewolucyjną technologię Pikaframes (sterowanie klatkami kluczowymi), obsługującą generowanie wideo 1080p HD o długości do 10 sekund. Niezależnie od tego, czy chcesz uzyskać płynne przejścia metamorfozy, czy stworzyć niesamowite efekty fizyczne, Pika 2.2 pozwala Twojej kreatywności płynąć na wyciągnięcie ręki dzięki precyzyjnej kontroli. Wypróbuj Pika 2.2 w WeryAI.',

        // Tabs
        tabImageToVideo: 'Obraz na wideo',
        tabTextToVideo: 'Tekst na wideo',

        // Core features section
        coreFeaturesTitle: 'Kluczowe funkcje Pika 2.2',

        // Features
        feature1Title: 'Sterowanie klatkami kluczowymi Pikaframes: opanowanie czasu i przestrzeni',
        feature1Description: 'To najbardziej przełomowa aktualizacja w Pika 2.2! Możesz teraz przesyłać klatki początkowe i końcowe, a AI inteligentnie obliczy i wygeneruje płynne animacje przejścia między nimi. Koniec z niekontrolowaną losową metamorfozą — możesz precyzyjnie reżyserować każdy moment, od „wykluwania się ptaka z jajka”, przez „szkic stający się rzeczywistością”, aż po „zmianę stroju postaci”.',
        feature2Title: 'Generowanie 10-sekundowych filmów dla pełnej narracji',
        feature2Description: 'Pożegnaj się z krótkimi 3-sekundowymi klipami. Pika 2.2 podwaja limit generowania wideo do 10 sekund. Oznacza to, że możesz opowiedzieć kompletną mini-historię w jednym ujęciu, zaprezentować bogatszą grę aktorską postaci, bardziej złożone ruchy kamery i odblokować więcej możliwości tworzenia krótkich filmów.',
        feature3Title: 'Kreatywne efekty fizyczne Pikaffects: wszystko jest zabawą',
        feature3Description: 'Klasyczne efekty fizyczne Pika są jeszcze bardziej realistyczne w wersji 2.2. Za pomocą jednego polecenia możesz sprawić, że obiekty w Twoim filmie przeciwstawią się prawom fizyki i stworzą oszałamiające spektakle wizualne. Obsługuje Melt (topienie), Crush (miażdżenie), Inflate (pompowanie), Cake-ify (zamiana w ciasto) i wiele innych kreatywnych efektów.',
        feature4Title: 'Kinowa jakość obrazu 1080p z krystalicznie czystymi detalami',
        feature4Description: 'Rozmycie nie jest już synonimem wideo AI. Pika 2.2 natywnie obsługuje rozdzielczość 1080p HD — czy to pasma włosów, tekstury tkanin, czy subtelne zmiany światła, wszystko jest ostre i wyraźne, spełniając standardy publikacji w mediach społecznościowych bezpośrednio po wygenerowaniu.',

        // How to use section
        howToUseTitle: 'Jak używać',
        step1Title: 'Wybierz model Pika 2.2',
        step1Description: 'Przejdź do strony „Generowanie wideo AI” i wybierz „Pika 2.2” z rozwijanego menu modeli.',
        step2Title: 'Wprowadź swoje kreatywne pomysły',
        step2Description: 'Wprowadź opis tekstowy lub prześlij obrazy jako materiały referencyjne. Obsługuje przesyłanie dwóch obrazów Pikaframes.',
        step3Title: 'Pobierz swoje wideo',
        step3Description: 'Kliknij „Utwórz” i pobierz lub udostępnij po zakończeniu generowania wideo.',

        // YouTube videos section
        youtubeTitle: 'Filmy na YouTube o Pika 2.2',

        // X Posts section
        xPostsTitle: 'Popularne posty na X o Pika 2.2',

        // Explore other models section
        exploreModelsTitle: 'Poznaj inne modele',
        seedanceTitle: 'Generator wideo AI Seedance 1.0 Pro',
        sora2Title: 'Generator wideo AI OpenAI Sora-2',
        runwayTitle: 'Generator wideo AI Runway',

        // FAQ section
        faqTitle: 'Często zadawane pytania',

        // CTA section
        ctaTitle: 'Gotowy, aby zacząć tworzyć?',
        ctaDescription: 'Doświadcz Pika 2.2 już teraz i przekształć swoją kreatywność w niesamowite filmy',
        ctaButton: 'Zacznij tworzyć',
        ctaDisclaimer: 'Karta kredytowa nie jest wymagana · Darmowy okres próbny dla nowych użytkowników',
    },
    es: {
        pageTitle: 'Generador de Video Pika 2.2 IA - Control de Keyframes Pikaframes, Videos 1080p HD de 10 Segundos',
        pageDescription: 'Experimenta la última obra maestra de Pika Labs, Pika 2.2, con tecnología revolucionaria de control de keyframes Pikaframes, soportando generación de videos 1080p HD de hasta 10 segundos. Pruébalo ahora en WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, control de keyframes, generador de video IA, 1080p, Pikaffects, texto a video, imagen a video, WeryAI',
        generatorTitle: 'Generador de Video Pika IA (Pika Labs)',
        generatorDescription: 'WeryAI ahora integra profundamente el modelo Pika 2.2, ya está aquí! Introduciendo la revolucionaria tecnología Pikaframes (control de keyframes), soportando generación de videos 1080p HD de hasta 10 segundos. Ya sea que quieras lograr transiciones de morphing suaves o crear efectos físicos alucinantes, Pika 2.2 permite que tu creatividad fluya en tus dedos con control preciso. Experimenta Pika 2.2 ahora en WeryAI.',
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',
        coreFeaturesTitle: 'Funciones Principales de Pika 2.2',
        feature1Title: 'Control de Keyframes Pikaframes: Dominando el Tiempo y el Espacio',
        feature1Description: '¡Esta es la actualización más disruptiva de Pika 2.2! Ahora puedes subir frames de inicio y fin, y la IA calculará inteligentemente y generará animaciones de transición suaves entre ellos. No más morphing aleatorio incontrolable—puedes dirigir precisamente cada momento de "huevo convirtiéndose en pájaro", "boceto a realidad", o "cambio de vestuario del personaje".',
        feature2Title: 'Generación de Videos Largos de 10 Segundos para Narrativa Completa',
        feature2Description: 'Despídete de los breves clips de 3 segundos. Pika 2.2 duplica el límite de generación de video a 10 segundos. Esto significa que puedes contar una mini-historia completa en una toma, mostrar actuaciones de personajes más ricas, movimientos de cámara más complejos, y desbloquear más posibilidades para la creación de videos cortos.',
        feature3Title: 'Efectos Físicos Creativos Pikaffects: Todo es Jugable',
        feature3Description: 'Los efectos físicos clásicos de Pika son aún más realistas en la versión 2.2. Con un solo comando, puedes hacer que los objetos en tu video desafíen las leyes de la física y crear espectáculos visuales impresionantes. Soporta Melt (derretir), Crush (aplastar), Inflate (inflar), Cake-ify (convertir en pastel), y muchos otros efectos creativos.',
        feature4Title: 'Visuales de Calidad Cinematográfica 1080p con Detalles Cristalinos',
        feature4Description: 'El desenfoque ya no es sinónimo de video IA. Pika 2.2 soporta nativamente resolución 1080p HD—ya sean hebras de cabello, texturas de tela, o variaciones sutiles de luz, todo es nítido y definido, cumpliendo con los estándares de publicación en redes sociales directamente.',
        howToUseTitle: 'Cómo Usar',
        step1Title: 'Seleccionar Modelo Pika 2.2',
        step1Description: 'Ve a la página "Generación de Video IA" y selecciona "Pika 2.2" del menú desplegable de modelos.',
        step2Title: 'Ingresa Tus Ideas Creativas',
        step2Description: 'Ingresa una descripción de texto, o sube imágenes como materiales de referencia. Soporta carga de imágenes duales Pikaframes.',
        step3Title: 'Descarga Tu Video',
        step3Description: 'Haz clic en "Crear" y descarga o comparte una vez que la generación del video esté completa.',
        youtubeTitle: 'Videos de YouTube Sobre Pika 2.2',
        xPostsTitle: 'Publicaciones Populares de X Sobre Pika 2.2',
        exploreModelsTitle: 'Explorar Otros Modelos',
        seedanceTitle: 'Generador de Video IA Seedance 1.0 Pro',
        sora2Title: 'Generador de Video IA OpenAI Sora-2',
        runwayTitle: 'Generador de Video IA Runway',
        faqTitle: 'Preguntas Frecuentes',
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta Pika 2.2 ahora y transforma tu creatividad en videos increíbles',
        ctaButton: 'Prueba Pika 2.2 en WeryAI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    },
    fr: {
        pageTitle: 'Générateur de Vidéo Pika 2.2 IA - Contrôle Keyframe Pikaframes, Vidéos 1080p HD de 10 Secondes',
        pageDescription: 'Découvrez le dernier chef-d\'œuvre de Pika Labs, Pika 2.2, avec la technologie révolutionnaire de contrôle keyframe Pikaframes, supportant jusqu\'à 10 secondes de génération vidéo 1080p HD. Essayez maintenant sur WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, contrôle keyframe, générateur vidéo IA, 1080p, Pikaffects, texte vers vidéo, image vers vidéo, WeryAI',
        generatorTitle: 'Générateur de Vidéo Pika IA (Pika Labs)',
        generatorDescription: 'WeryAI intègre désormais en profondeur le modèle Pika 2.2, est arrivé ! Introduisant la technologie révolutionnaire Pikaframes (contrôle keyframe), supportant jusqu\'à 10 secondes de génération vidéo 1080p HD. Que vous souhaitiez réaliser des transitions de morphing fluides ou créer des effets physiques époustouflants, Pika 2.2 permet à votre créativité de s\'exprimer du bout des doigts avec un contrôle précis. Découvrez Pika 2.2 maintenant sur WeryAI.',
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',
        coreFeaturesTitle: 'Fonctionnalités Principales de Pika 2.2',
        feature1Title: 'Contrôle Keyframe Pikaframes : Maîtriser le Temps et l\'Espace',
        feature1Description: 'C\'est la mise à jour la plus disruptive de Pika 2.2 ! Vous pouvez maintenant télécharger des frames de début et de fin, et l\'IA calculera intelligemment et générera des animations de transition fluides entre eux. Plus de morphing aléatoire incontrôlable—vous pouvez diriger précisément chaque moment de "l\'œuf qui devient oiseau", "du croquis à la réalité", ou "changement de costume du personnage".',
        feature2Title: 'Génération de Vidéos Longues de 10 Secondes pour une Narration Complète',
        feature2Description: 'Dites adieu aux clips brefs de 3 secondes. Pika 2.2 double la limite de génération vidéo à 10 secondes. Cela signifie que vous pouvez raconter une mini-histoire complète en une prise, présenter des performances de personnages plus riches, des mouvements de caméra plus complexes, et débloquer plus de possibilités pour la création de vidéos courtes.',
        feature3Title: 'Effets Physiques Créatifs Pikaffects : Tout est Jouable',
        feature3Description: 'Les effets physiques classiques de Pika sont encore plus réalistes dans la version 2.2. Avec une seule commande, vous pouvez faire défier les lois de la physique aux objets de votre vidéo et créer des spectacles visuels époustouflants. Supporte Melt (fondre), Crush (écraser), Inflate (gonfler), Cake-ify (transformer en gâteau), et bien d\'autres effets créatifs.',
        feature4Title: 'Visuels de Qualité Cinématographique 1080p avec Détails Cristallins',
        feature4Description: 'Le flou n\'est plus synonyme de vidéo IA. Pika 2.2 supporte nativement la résolution 1080p HD—que ce soient les mèches de cheveux, les textures de tissu, ou les variations subtiles de lumière, tout est net et précis, répondant directement aux standards de publication sur les réseaux sociaux.',
        howToUseTitle: 'Comment Utiliser',
        step1Title: 'Sélectionner le Modèle Pika 2.2',
        step1Description: 'Allez sur la page "Génération de Vidéo IA" et sélectionnez "Pika 2.2" dans le menu déroulant des modèles.',
        step2Title: 'Entrez Vos Idées Créatives',
        step2Description: 'Entrez une description textuelle, ou téléchargez des images comme matériaux de référence. Supporte le téléchargement d\'images doubles Pikaframes.',
        step3Title: 'Téléchargez Votre Vidéo',
        step3Description: 'Cliquez sur "Créer" et téléchargez ou partagez une fois la génération vidéo terminée.',
        youtubeTitle: 'Vidéos YouTube Sur Pika 2.2',
        xPostsTitle: 'Publications X Populaires Sur Pika 2.2',
        exploreModelsTitle: 'Explorer d\'Autres Modèles',
        seedanceTitle: 'Générateur de Vidéo IA Seedance 1.0 Pro',
        sora2Title: 'Générateur de Vidéo IA OpenAI Sora-2',
        runwayTitle: 'Générateur de Vidéo IA Runway',
        faqTitle: 'Questions Fréquemment Posées',
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Découvrez Pika 2.2 maintenant et transformez votre créativité en vidéos incroyables',
        ctaButton: 'Essayez Pika 2.2 sur WeryAI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
    },
    de: {
        pageTitle: 'Pika 2.2 KI-Videogenerator - Pikaframes Keyframe-Steuerung, 10-Sekunden 1080p HD-Videos',
        pageDescription: 'Erleben Sie Pika Labs neuestes Meisterwerk Pika 2.2 mit revolutionärer Pikaframes Keyframe-Steuerungstechnologie, die bis zu 10 Sekunden 1080p HD-Videogenerierung unterstützt. Jetzt auf WeryAI testen.',
        pageKeywords: 'Pika 2.2, Pikaframes, Keyframe-Steuerung, KI-Videogenerator, 1080p, Pikaffects, Text zu Video, Bild zu Video, WeryAI',
        generatorTitle: 'Pika KI-Videogenerator (Pika Labs)',
        generatorDescription: 'WeryAI integriert jetzt das Modell Pika 2.2 tiefgreifend, Mit revolutionärer Pikaframes (Keyframe-Steuerung) Technologie, die bis zu 10 Sekunden 1080p HD-Videogenerierung unterstützt. Ob fließende Morphing-Übergänge oder atemberaubende Physikeffekte—Pika 2.2 lässt Ihre Kreativität mit präziser Kontrolle an Ihren Fingerspitzen fließen. Erleben Sie Pika 2.2 jetzt auf WeryAI.',
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',
        coreFeaturesTitle: 'Pika 2.2 Kernfunktionen',
        feature1Title: 'Pikaframes Keyframe-Steuerung: Zeit und Raum Beherrschen',
        feature1Description: 'Dies ist Pika 2.2s disruptivste Aktualisierung! Sie können jetzt Start- und Endframes hochladen, und die KI berechnet intelligent und generiert fließende Übergangsanimationen zwischen ihnen. Kein unkontrollierbares zufälliges Morphing mehr—Sie können jeden Moment von "Ei wird zum Vogel", "Skizze zu Realität" oder "Charakterkostümwechsel" präzise inszenieren.',
        feature2Title: '10-Sekunden-Langvideos für Vollständiges Storytelling',
        feature2Description: 'Verabschieden Sie sich von kurzen 3-Sekunden-Clips. Pika 2.2 verdoppelt das Videogenerierungslimit auf 10 Sekunden. Das bedeutet, Sie können in einer Aufnahme eine vollständige Mini-Geschichte erzählen, reichhaltigere Charakterdarstellungen, komplexere Kamerabewegungen zeigen und mehr Möglichkeiten für die Kurzvideoerstellung freischalten.',
        feature3Title: 'Pikaffects Kreative Physikeffekte: Alles ist Spielbar',
        feature3Description: 'Pikas klassische Physikeffekte sind in Version 2.2 noch realistischer. Mit nur einem Befehl können Sie Objekte in Ihrem Video die Gesetze der Physik missachten lassen und atemberaubende visuelle Spektakel schaffen. Unterstützt Melt (Schmelzen), Crush (Zerquetschen), Inflate (Aufblasen), Cake-ify (In Kuchen verwandeln) und viele andere kreative Effekte.',
        feature4Title: '1080p Kinoqualität mit Kristallklaren Details',
        feature4Description: 'Unschärfe ist nicht mehr gleichbedeutend mit KI-Video. Pika 2.2 unterstützt nativ 1080p HD-Auflösung—ob Haarsträhnen, Stofftexturen oder subtile Lichtvariationen, alles ist scharf und klar und erfüllt direkt die Veröffentlichungsstandards für soziale Medien.',
        howToUseTitle: 'Wie Man Verwendet',
        step1Title: 'Pika 2.2 Modell Auswählen',
        step1Description: 'Gehen Sie zur Seite "KI-Videogenerierung" und wählen Sie "Pika 2.2" aus dem Modell-Dropdown-Menü.',
        step2Title: 'Geben Sie Ihre Kreativen Ideen Ein',
        step2Description: 'Geben Sie eine Textbeschreibung ein oder laden Sie Bilder als Referenzmaterialien hoch. Unterstützt Pikaframes Dual-Bild-Upload.',
        step3Title: 'Laden Sie Ihr Video Herunter',
        step3Description: 'Klicken Sie auf "Erstellen" und laden Sie herunter oder teilen Sie, sobald die Videogenerierung abgeschlossen ist.',
        youtubeTitle: 'YouTube-Videos Über Pika 2.2',
        xPostsTitle: 'Beliebte X-Beiträge Über Pika 2.2',
        exploreModelsTitle: 'Andere Modelle Erkunden',
        seedanceTitle: 'Seedance 1.0 Pro KI-Videogenerator',
        sora2Title: 'OpenAI Sora-2 KI-Videogenerator',
        runwayTitle: 'Runway KI-Videogenerator',
        faqTitle: 'Häufig Gestellte Fragen',
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie Pika 2.2 jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaButton: 'Testen Sie Pika 2.2 auf WeryAI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    },
    ru: {
        // SEO Meta
        pageTitle: 'Pika 2.2 ИИ-Генератор Видео - Управление Ключевыми Кадрами Pikaframes, 10-Секундные 1080p HD Видео',
        pageDescription: 'Попробуйте последний шедевр Pika Labs Pika 2.2 с революционной технологией управления ключевыми кадрами Pikaframes, поддерживающей генерацию 1080p HD видео до 10 секунд. Попробуйте сейчас на WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, управление ключевыми кадрами, ИИ-генератор видео, 1080p, Pikaffects, текст в видео, изображение в видео, WeryAI',
        generatorTitle: 'Pika ИИ-Генератор Видео (Pika Labs)',
        generatorDescription: 'WeryAI теперь глубоко интегрировал модель Pika 2.2, Представляем революционную технологию Pikaframes (управление ключевыми кадрами), поддерживающую генерацию 1080p HD видео до 10 секунд. Хотите ли вы создать плавные морфинг-переходы или потрясающие физические эффекты, Pika 2.2 позволяет вашему творчеству течь на кончиках пальцев с точным контролем. Попробуйте Pika 2.2 сейчас на WeryAI.',
        tabImageToVideo: 'Изображение в Видео',
        tabTextToVideo: 'Текст в Видео',
        coreFeaturesTitle: 'Основные Функции Pika 2.2',
        feature1Title: 'Управление Ключевыми Кадрами Pikaframes: Власть над Временем и Пространством',
        feature1Description: 'Это самое революционное обновление Pika 2.2! Теперь вы можете загружать начальный и конечный кадры, а ИИ интеллектуально рассчитает и создаст плавные переходные анимации между ними. Больше никакого неконтролируемого случайного морфинга—вы можете точно режиссировать каждый момент "яйцо превращается в птицу", "набросок становится реальностью" или "смена костюма персонажа".',
        feature2Title: '10-Секундная Генерация Длинных Видео для Полного Повествования',
        feature2Description: 'Попрощайтесь с короткими 3-секундными клипами. Pika 2.2 удваивает лимит генерации видео до 10 секунд. Это значит, что вы можете рассказать полную мини-историю одним кадром, показать более богатую игру персонажей, более сложные движения камеры и открыть больше возможностей для создания коротких видео.',
        feature3Title: 'Творческие Физические Эффекты Pikaffects: Всё Можно Играть',
        feature3Description: 'Классические физические эффекты Pika стали ещё реалистичнее в версии 2.2. Одной командой вы можете заставить объекты в вашем видео нарушать законы физики и создавать потрясающие визуальные зрелища. Поддерживает Melt (плавление), Crush (сдавливание), Inflate (надувание), Cake-ify (превращение в торт) и многие другие творческие эффекты.',
        feature4Title: '1080p Кинематографическое Качество с Кристально Чёткими Деталями',
        feature4Description: 'Размытость больше не является синонимом ИИ-видео. Pika 2.2 нативно поддерживает разрешение 1080p HD—будь то пряди волос, текстуры ткани или тонкие вариации света, всё чёткое и резкое, соответствующее стандартам публикации в социальных сетях.',
        howToUseTitle: 'Как Использовать',
        step1Title: 'Выберите Модель Pika 2.2',
        step1Description: 'Перейдите на страницу "Генерация ИИ-Видео" и выберите "Pika 2.2" в выпадающем меню моделей.',
        step2Title: 'Введите Ваши Творческие Идеи',
        step2Description: 'Введите текстовое описание или загрузите изображения в качестве справочных материалов. Поддерживается двойная загрузка изображений Pikaframes.',
        step3Title: 'Скачайте Ваше Видео',
        step3Description: 'Нажмите "Создать" и скачайте или поделитесь после завершения генерации видео.',
        youtubeTitle: 'YouTube Видео о Pika 2.2',
        xPostsTitle: 'Популярные Посты X о Pika 2.2',
        exploreModelsTitle: 'Исследовать Другие Модели',
        seedanceTitle: 'Seedance 1.0 Pro ИИ-Генератор Видео',
        sora2Title: 'OpenAI Sora-2 ИИ-Генератор Видео',
        runwayTitle: 'Runway ИИ-Генератор Видео',
        faqTitle: 'Часто Задаваемые Вопросы',
        ctaTitle: 'Готовы Начать Создавать?',
        ctaDescription: 'Попробуйте Pika 2.2 сейчас и превратите вашу креативность в потрясающие видео',
        ctaButton: 'Попробуйте Pika 2.2 на WeryAI',
        ctaDisclaimer: 'Кредитная карта не требуется',
    },
    pt: {
        // SEO Meta
        pageTitle: 'Pika 2.2 Gerador de Vídeo IA - Controle de Keyframe Pikaframes, Vídeos 1080p HD de 10 Segundos',
        pageDescription: 'Experimente a última obra-prima da Pika Labs, Pika 2.2, com tecnologia revolucionária de controle de keyframe Pikaframes, suportando geração de vídeos 1080p HD de até 10 segundos. Experimente agora no WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, controle de keyframe, gerador de vídeo IA, 1080p, Pikaffects, texto para vídeo, imagem para vídeo, WeryAI',
        generatorTitle: 'Pika Gerador de Vídeo IA (Pika Labs)',
        generatorDescription: 'O WeryAI agora integra profundamente o modelo Pika 2.2, chegou! Apresentando a revolucionária tecnologia Pikaframes (controle de keyframe), suportando geração de vídeos 1080p HD de até 10 segundos. Seja para criar transições de morphing suaves ou efeitos físicos impressionantes, Pika 2.2 permite que sua criatividade flua na ponta dos dedos com controle preciso. Experimente Pika 2.2 agora no WeryAI.',
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',
        coreFeaturesTitle: 'Recursos Principais do Pika 2.2',
        feature1Title: 'Controle de Keyframe Pikaframes: Dominando Tempo e Espaço',
        feature1Description: 'Esta é a atualização mais disruptiva do Pika 2.2! Agora você pode enviar frames de início e fim, e a IA calculará inteligentemente e gerará animações de transição suaves entre eles. Não há mais morphing aleatório incontrolável—você pode dirigir precisamente cada momento de "ovo se transformando em pássaro", "esboço para realidade" ou "troca de roupa do personagem".',
        feature2Title: 'Geração de Vídeos Longos de 10 Segundos para Narrativa Completa',
        feature2Description: 'Diga adeus aos breves clipes de 3 segundos. Pika 2.2 dobra o limite de geração de vídeo para 10 segundos. Isso significa que você pode contar uma mini-história completa em uma tomada, mostrar performances de personagens mais ricas, movimentos de câmera mais complexos e desbloquear mais possibilidades para criação de vídeos curtos.',
        feature3Title: 'Efeitos Físicos Criativos Pikaffects: Tudo é Jogável',
        feature3Description: 'Os efeitos físicos clássicos do Pika são ainda mais realistas na versão 2.2. Com apenas um comando, você pode fazer objetos em seu vídeo desafiarem as leis da física e criar espetáculos visuais impressionantes. Suporta Melt (derreter), Crush (esmagar), Inflate (inflar), Cake-ify (transformar em bolo) e muitos outros efeitos criativos.',
        feature4Title: 'Visuais de Qualidade Cinematográfica 1080p com Detalhes Cristalinos',
        feature4Description: 'Desfoque não é mais sinônimo de vídeo IA. Pika 2.2 suporta nativamente resolução 1080p HD—seja fios de cabelo, texturas de tecido ou variações sutis de luz, tudo é nítido e claro, atendendo aos padrões de publicação em redes sociais.',
        howToUseTitle: 'Como Usar',
        step1Title: 'Selecionar Modelo Pika 2.2',
        step1Description: 'Vá para a página "Geração de Vídeo IA" e selecione "Pika 2.2" no menu suspenso de modelos.',
        step2Title: 'Insira Suas Ideias Criativas',
        step2Description: 'Insira uma descrição de texto ou envie imagens como materiais de referência. Suporta upload de imagens duplas Pikaframes.',
        step3Title: 'Baixe Seu Vídeo',
        step3Description: 'Clique em "Criar" e baixe ou compartilhe assim que a geração do vídeo estiver completa.',
        youtubeTitle: 'Vídeos do YouTube Sobre Pika 2.2',
        xPostsTitle: 'Posts Populares do X Sobre Pika 2.2',
        exploreModelsTitle: 'Explorar Outros Modelos',
        seedanceTitle: 'Seedance 1.0 Pro Gerador de Vídeo IA',
        sora2Title: 'OpenAI Sora-2 Gerador de Vídeo IA',
        runwayTitle: 'Runway Gerador de Vídeo IA',
        faqTitle: 'Perguntas Frequentes',
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente Pika 2.2 agora e transforme sua criatividade em vídeos incríveis',
        ctaButton: 'Experimente Pika 2.2 no WeryAI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    it: {
        // SEO Meta
        pageTitle: 'Pika 2.2 Generatore Video IA - Controllo Keyframe Pikaframes, Video 1080p HD di 10 Secondi',
        pageDescription: 'Prova l\'ultimo capolavoro di Pika Labs, Pika 2.2, con la rivoluzionaria tecnologia di controllo keyframe Pikaframes, che supporta la generazione di video 1080p HD fino a 10 secondi. Prova ora su WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, controllo keyframe, generatore video IA, 1080p, Pikaffects, testo a video, immagine a video, WeryAI',
        generatorTitle: 'Pika Generatore Video IA (Pika Labs)',
        generatorDescription: 'WeryAI integra ora in profondità il modello Pika 2.2, è arrivato! Presenta la rivoluzionaria tecnologia Pikaframes (controllo keyframe), che supporta la generazione di video 1080p HD fino a 10 secondi. Che tu voglia creare transizioni di morphing fluide o effetti fisici sbalorditivi, Pika 2.2 permette alla tua creatività di fluire sulla punta delle dita con controllo preciso. Prova Pika 2.2 ora su WeryAI.',
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',
        coreFeaturesTitle: 'Funzionalità Principali di Pika 2.2',
        feature1Title: 'Controllo Keyframe Pikaframes: Padroneggiare Tempo e Spazio',
        feature1Description: 'Questo è l\'aggiornamento più dirompente di Pika 2.2! Ora puoi caricare frame di inizio e fine, e l\'IA calcolerà intelligentemente e genererà animazioni di transizione fluide tra di loro. Niente più morphing casuale incontrollabile—puoi dirigere con precisione ogni momento di "uovo che diventa uccello", "schizzo a realtà" o "cambio costume del personaggio".',
        feature2Title: 'Generazione Video Lunghi di 10 Secondi per Narrazione Completa',
        feature2Description: 'Dì addio ai brevi clip di 3 secondi. Pika 2.2 raddoppia il limite di generazione video a 10 secondi. Questo significa che puoi raccontare una mini-storia completa in un\'unica ripresa, mostrare performance di personaggi più ricche, movimenti di camera più complessi e sbloccare più possibilità per la creazione di video brevi.',
        feature3Title: 'Effetti Fisici Creativi Pikaffects: Tutto è Giocabile',
        feature3Description: 'Gli effetti fisici classici di Pika sono ancora più realistici nella versione 2.2. Con un solo comando, puoi far sfidare le leggi della fisica agli oggetti nel tuo video e creare spettacoli visivi sorprendenti. Supporta Melt (sciogliere), Crush (schiacciare), Inflate (gonfiare), Cake-ify (trasformare in torta) e molti altri effetti creativi.',
        feature4Title: 'Visual di Qualità Cinematografica 1080p con Dettagli Cristallini',
        feature4Description: 'La sfocatura non è più sinonimo di video IA. Pika 2.2 supporta nativamente la risoluzione 1080p HD—che siano ciocche di capelli, texture di tessuti o variazioni sottili di luce, tutto è nitido e chiaro, soddisfacendo gli standard di pubblicazione sui social media.',
        howToUseTitle: 'Come Usare',
        step1Title: 'Seleziona il Modello Pika 2.2',
        step1Description: 'Vai alla pagina "Generazione Video IA" e seleziona "Pika 2.2" dal menu a discesa dei modelli.',
        step2Title: 'Inserisci le Tue Idee Creative',
        step2Description: 'Inserisci una descrizione testuale o carica immagini come materiali di riferimento. Supporta il caricamento di immagini doppie Pikaframes.',
        step3Title: 'Scarica il Tuo Video',
        step3Description: 'Clicca su "Crea" e scarica o condividi una volta completata la generazione del video.',
        youtubeTitle: 'Video YouTube Su Pika 2.2',
        xPostsTitle: 'Post Popolari X Su Pika 2.2',
        exploreModelsTitle: 'Esplora Altri Modelli',
        seedanceTitle: 'Seedance 1.0 Pro Generatore Video IA',
        sora2Title: 'OpenAI Sora-2 Generatore Video IA',
        runwayTitle: 'Runway Generatore Video IA',
        faqTitle: 'Domande Frequenti',
        ctaTitle: 'Pronto a Iniziare a Creare?',
        ctaDescription: 'Prova Pika 2.2 ora e trasforma la tua creatività in video incredibili',
        ctaButton: 'Prova Pika 2.2 su WeryAI',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',
    },
    ar: {
        // SEO Meta
        pageTitle: 'Pika 2.2 مولد الفيديو بالذكاء الاصطناعي - تحكم Pikaframes بالإطارات الرئيسية، فيديوهات 1080p HD لمدة 10 ثوانٍ',
        pageDescription: 'جرب أحدث تحفة Pika Labs، Pika 2.2، مع تقنية التحكم الثورية بالإطارات الرئيسية Pikaframes، التي تدعم إنشاء فيديوهات 1080p HD تصل إلى 10 ثوانٍ. جربه الآن على WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, تحكم بالإطارات الرئيسية, مولد فيديو بالذكاء الاصطناعي, 1080p, Pikaffects, نص إلى فيديو, صورة إلى فيديو, WeryAI',
        generatorTitle: 'Pika مولد الفيديو بالذكاء الاصطناعي (Pika Labs)',
        generatorDescription: 'يقوم WeryAI الآن بدمج نموذج Pika 2.2 بعمق، يقدم تقنية Pikaframes الثورية (تحكم بالإطارات الرئيسية)، التي تدعم إنشاء فيديوهات 1080p HD تصل إلى 10 ثوانٍ. سواء كنت تريد تحقيق انتقالات تحول سلسة أو إنشاء تأثيرات فيزيائية مذهلة، Pika 2.2 يتيح لإبداعك التدفق على أطراف أصابعك بتحكم دقيق. جرب Pika 2.2 الآن على WeryAI.',
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',
        coreFeaturesTitle: 'الميزات الأساسية لـ Pika 2.2',
        feature1Title: 'تحكم Pikaframes بالإطارات الرئيسية: السيطرة على الزمان والمكان',
        feature1Description: 'هذا هو التحديث الأكثر ثورية في Pika 2.2! يمكنك الآن رفع إطارات البداية والنهاية، وسيقوم الذكاء الاصطناعي بالحساب بذكاء وإنشاء رسوم متحركة انتقالية سلسة بينهما. لا مزيد من التحول العشوائي غير المتحكم—يمكنك توجيه كل لحظة بدقة من "البيضة تتحول إلى طائر"، "الرسم إلى الواقع"، أو "تغيير زي الشخصية".',
        feature2Title: 'إنشاء فيديوهات طويلة 10 ثوانٍ لسرد قصصي كامل',
        feature2Description: 'ودع مقاطع الـ 3 ثوانٍ القصيرة. Pika 2.2 يضاعف حد إنشاء الفيديو إلى 10 ثوانٍ. هذا يعني أنه يمكنك سرد قصة صغيرة كاملة في لقطة واحدة، وعرض أداء شخصيات أكثر ثراءً، وحركات كاميرا أكثر تعقيداً، وفتح المزيد من الإمكانيات لإنشاء الفيديوهات القصيرة.',
        feature3Title: 'تأثيرات Pikaffects الفيزيائية الإبداعية: كل شيء قابل للعب',
        feature3Description: 'التأثيرات الفيزيائية الكلاسيكية لـ Pika أصبحت أكثر واقعية في الإصدار 2.2. بأمر واحد فقط، يمكنك جعل الأشياء في الفيديو تتحدى قوانين الفيزياء وتخلق مشاهد بصرية مذهلة. يدعم Melt (ذوبان)، Crush (سحق)، Inflate (نفخ)، Cake-ify (تحويل إلى كعكة) والعديد من التأثيرات الإبداعية الأخرى.',
        feature4Title: 'جودة سينمائية 1080p مع تفاصيل واضحة كالكريستال',
        feature4Description: 'الضبابية لم تعد مرادفة لفيديو الذكاء الاصطناعي. Pika 2.2 يدعم أصلاً دقة 1080p HD—سواء كانت خيوط الشعر، أو نسيج القماش، أو التغيرات الدقيقة في الضوء، كل شيء واضح وحاد، يلبي معايير النشر على وسائل التواصل الاجتماعي.',
        howToUseTitle: 'كيفية الاستخدام',
        step1Title: 'اختر نموذج Pika 2.2',
        step1Description: 'انتقل إلى صفحة "إنشاء فيديو بالذكاء الاصطناعي" واختر "Pika 2.2" من قائمة النماذج المنسدلة.',
        step2Title: 'أدخل أفكارك الإبداعية',
        step2Description: 'أدخل وصفاً نصياً أو ارفع صوراً كمواد مرجعية. يدعم رفع صورتين Pikaframes.',
        step3Title: 'حمل الفيديو الخاص بك',
        step3Description: 'انقر على "إنشاء" ثم حمل أو شارك بمجرد اكتمال إنشاء الفيديو.',
        youtubeTitle: 'فيديوهات YouTube عن Pika 2.2',
        xPostsTitle: 'منشورات X الشائعة عن Pika 2.2',
        exploreModelsTitle: 'استكشف نماذج أخرى',
        seedanceTitle: 'Seedance 1.0 Pro مولد فيديو بالذكاء الاصطناعي',
        sora2Title: 'OpenAI Sora-2 مولد فيديو بالذكاء الاصطناعي',
        runwayTitle: 'Runway مولد فيديو بالذكاء الاصطناعي',
        faqTitle: 'الأسئلة الشائعة',
        ctaTitle: 'مستعد للبدء في الإنشاء؟',
        ctaDescription: 'جرب Pika 2.2 الآن وحول إبداعك إلى فيديوهات مذهلة',
        ctaButton: 'جرب Pika 2.2 على WeryAI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        },
    th: {
        // SEO Meta
        pageTitle: 'Pika 2.2 เครื่องสร้างวิดีโอ AI - ควบคุมคีย์เฟรม Pikaframes, วิดีโอ HD 1080p ยาว 10 วินาที',
        pageDescription: 'สัมผัส Pika 2.2 ผลงานล่าสุดของ Pika Labs ด้วยเทคโนโลยีควบคุมคีย์เฟรม Pikaframes ที่ปฏิวัติวงการ รองรับการสร้างวิดีโอ HD 1080p สูงสุด 10 วินาที ทดลองได้ทันทีบน WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, ควบคุมคีย์เฟรม, เครื่องสร้างวิดีโอ AI, 1080p, Pikaffects, ข้อความเป็นวิดีโอ, ภาพเป็นวิดีโอ, WeryAI',

        // Generator section
        generatorTitle: 'Pika เครื่องสร้างวิดีโอ AI (Pika Labs)',
        generatorDescription: 'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Pika 2.2 อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Pika 2.2 อย่างลึกซึ้งแล้ว Pika 2.2 ผลงานล่าสุดจาก Pika Labs มาแล้ว! นำเทคโนโลยี Pikaframes (ควบคุมคีย์เฟรม) ที่ปฏิวัติวงการ รองรับการสร้างวิดีโอ HD 1080p ยาวถึง 10 วินาที ไม่ว่าคุณต้องการการแปลงร่างที่ลื่นไหลหรือเอฟเฟกต์ฟิสิกส์สุดล้ำ Pika 2.2 ทำให้ความคิดสร้างสรรค์ไหลลื่นอยู่ที่ปลายนิ้วพร้อมการควบคุมที่แม่นยำ ลองใช้ Pika 2.2 บน WeryAI ตอนนี้',

        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Pika 2.2',

        // Features
        feature1Title: 'ควบคุมคีย์เฟรม Pikaframes: คุมเวลาและพื้นที่',
        feature1Description: 'นี่คืออัปเดตที่เปลี่ยนเกมที่สุดของ Pika 2.2! คุณสามารถอัปโหลดเฟรมเริ่มต้นและเฟรมสิ้นสุด แล้ว AI จะคำนวณและสร้างแอนิเมชันทรานซิชันที่ลื่นไหลระหว่างกัน ไม่ต้องพึ่งการแปลงร่างแบบสุ่มที่ควบคุมไม่ได้อีกต่อไป คุณกำกับทุกช่วงเวลาได้อย่างแม่นยำ เช่น "ไข่ฟักเป็นนก", "สเก็ตช์กลายเป็นภาพจริง" หรือ "เปลี่ยนชุดตัวละคร".',
        feature2Title: 'สร้างวิดีโอยาว 10 วินาที เล่าเรื่องได้ครบ',
        feature2Description: 'บอกลาคลิปสั้น 3 วินาที Pika 2.2 เพิ่มระยะเวลาสูงสุดเป็น 10 วินาที คุณสามารถเล่าเรื่องย่อให้จบในช็อตเดียว แสดงการแสดงของตัวละครที่สมบูรณ์ขึ้น การเคลื่อนกล้องที่ซับซ้อนขึ้น และเปิดโอกาสใหม่ให้คอนเทนต์วิดีโอสั้น.',
        feature3Title: 'เอฟเฟกต์ฟิสิกส์สร้างสรรค์ Pikaffects: เล่นได้ทุกอย่าง',
        feature3Description: 'เอฟเฟกต์ฟิสิกส์สุดคลาสสิกของ Pika สมจริงยิ่งขึ้นในเวอร์ชัน 2.2 เพียงคำสั่งเดียวก็ทำให้วัตถุในวิดีโอละเมิดกฎฟิสิกส์และสร้างภาพสุดตระการตา รองรับ Melt, Crush, Inflate, Cake-ify และเอฟเฟกต์สร้างสรรค์อีกมากมาย.',
        feature4Title: 'คุณภาพระดับภาพยนตร์ 1080p รายละเอียดคมชัด',
        feature4Description: 'ความเบลอไม่ใช่ภาพจำของวิดีโอ AI อีกต่อไป Pika 2.2 รองรับความละเอียด HD 1080p โดยตรง ไม่ว่าจะเป็นเส้นผม เนื้อผ้า หรือการไล่แสงเล็กๆ ทุกอย่างคมชัด พร้อมเผยแพร่ลงโซเชียลได้ทันที.',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        step1Title: 'เลือกโมเดล Pika 2.2',
        step1Description: 'ไปที่หน้า "AI Video Generation" แล้วเลือก "Pika 2.2" จากเมนูโมเดล.',
        step2Title: 'ใส่ไอเดียของคุณ',
        step2Description: 'พิมพ์คำอธิบาย หรืออัปโหลดภาพเป็นอ้างอิง รองรับการอัปโหลดภาพคู่แบบ Pikaframes.',
        step3Title: 'ดาวน์โหลดวิดีโอของคุณ',
        step3Description: 'คลิก "Create" และดาวน์โหลดหรือแชร์เมื่อการสร้างเสร็จสิ้น.',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับ Pika 2.2',

        // X Posts section
        xPostsTitle: 'โพสต์ X ยอดนิยมเกี่ยวกับ Pika 2.2',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดลอื่นๆ',
        seedanceTitle: 'Seedance 1.0 Pro AI วิดีโอเจเนอเรเตอร์',
        sora2Title: 'OpenAI Sora-2 AI วิดีโอเจเนอเรเตอร์',
        runwayTitle: 'Runway AI วิดีโอเจเนอเรเตอร์',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',

        // CTA section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaDescription: 'ลองใช้ Pika 2.2 ตอนนี้และเปลี่ยนความคิดสร้างสรรค์เป็นวิดีโอสุดยอด',
        ctaButton: 'เริ่มสร้างสรรค์',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต · ทดลองใช้ฟรีสำหรับผู้ใช้ใหม่',
    },
    da: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI-videogenerator - Pikaframes keyframe-kontrol, 10 sekunders 1080p HD-videoer',
        pageDescription: 'Oplev Pika 2.2 fra Pika Labs med revolutionerende Pikaframes keyframe-kontrol, der understøtter op til 10 sekunders 1080p HD-videogenerering. Prøv nu på WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, keyframe-kontrol, AI-videogenerator, 1080p, Pikaffects, tekst til video, billede til video, WeryAI',

        // Generator section
        generatorTitle: 'Pika AI-videogenerator (Pika Labs)',
        generatorDescription: 'WeryAI har nu integreret modellen Pika 2.2 i dybden, Pika 2.2 fra Pika Labs er her! Med den revolutionerende Pikaframes-teknologi (keyframe-kontrol) understøttes op til 10 sekunders 1080p HD-videogenerering. Uanset om du vil have glidende morphing-overgange eller skabe vilde fysiske effekter, giver Pika 2.2 dig præcis kontrol over kreativiteten. Oplev Pika 2.2 på WeryAI nu.',

        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Pika 2.2 kernefunktioner',

        // Features
        feature1Title: 'Pikaframes keyframe-kontrol: mestring af tid og rum',
        feature1Description: 'Dette er den mest banebrydende opdatering i Pika 2.2. Du kan nu uploade start- og slutframes, og AI beregner og genererer glidende overgangsanimationer mellem dem. Ingen ukontrollerbar tilfældig morphing længere – du kan præcist instruere hvert øjeblik af "æg der klækker til fugl", "skitse til virkelighed" eller "karakterskift af tøj".',
        feature2Title: '10 sekunders video for fuld storytelling',
        feature2Description: 'Sig farvel til korte 3-sekunders klip. Pika 2.2 fordobler grænsen til 10 sekunder, så du kan fortælle en komplet mini-historie i ét skud, vise rigere karakterpræstationer, mere komplekse kamerabevægelser og få flere muligheder til korte videoer.',
        feature3Title: 'Pikaffects kreative fysikeffekter: alt kan leges med',
        feature3Description: 'Pikas klassiske fysikeffekter er endnu mere realistiske i version 2.2. Med én kommando kan du få objekter i videoen til at bryde fysikkens love og skabe imponerende visuelle effekter. Understøtter Melt, Crush, Inflate, Cake-ify og mange andre kreative effekter.',
        feature4Title: '1080p biografkvalitet med krystalklare detaljer',
        feature4Description: 'Slør er ikke længere synonymt med AI-video. Pika 2.2 understøtter 1080p HD-opløsning som standard – hvad enten det er hårstrå, stofteksturer eller subtile lysvariationer, er alt skarpt og klart, klar til publicering på sociale medier.',

        // How to use section
        howToUseTitle: 'Sådan bruges',
        step1Title: 'Vælg Pika 2.2-modellen',
        step1Description: 'Gå til siden "AI Video Generation" og vælg "Pika 2.2" i modelmenuen.',
        step2Title: 'Indtast dine kreative idéer',
        step2Description: 'Indtast en tekstbeskrivelse eller upload billeder som reference. Understøtter Pikaframes dobbeltbillede-upload.',
        step3Title: 'Download din video',
        step3Description: 'Klik på "Create", og download eller del når genereringen er færdig.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Pika 2.2',

        // X Posts section
        xPostsTitle: 'Populære X-opslag om Pika 2.2',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre modeller',
        seedanceTitle: 'Seedance 1.0 Pro AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',

        // CTA section
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaDescription: 'Oplev Pika 2.2 nu og forvandl din kreativitet til fantastiske videoer',
        ctaButton: 'Begynd at skabe',
        ctaDisclaimer: 'Intet kreditkort kræves · Gratis prøveperiode for nye brugere',
    },
    no: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI-videogenerator – Pikaframes keyframe-kontroll, 10-sekunders 1080p HD-videoer',
        pageDescription: 'Opplev Pika 2.2 fra Pika Labs med revolusjonerende Pikaframes keyframe-kontroll som støtter opptil 10 sekunders 1080p HD-videogenerering. Prøv nå på WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, keyframe-kontroll, AI-videogenerator, 1080p, Pikaffects, tekst til video, bilde til video, WeryAI',

        // Generator section
        generatorTitle: 'Pika AI-videogenerator (Pika Labs)',
        generatorDescription: 'WeryAI har nå integrert modellen Pika 2.2 i dybden, Pika 2.2 fra Pika Labs er her! Med den revolusjonerende Pikaframes-teknologien (keyframe-kontroll) støttes opptil 10 sekunders 1080p HD-videogenerering. Enten du vil ha glatte morphing-overganger eller lage spektakulære fysikkeffekter, gir Pika 2.2 presis kontroll over kreativiteten. Opplev Pika 2.2 på WeryAI nå.',

        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Pika 2.2 kjernefunksjoner',

        // Features
        feature1Title: 'Pikaframes keyframe-kontroll: mestre tid og rom',
        feature1Description: 'Dette er den mest banebrytende oppdateringen i Pika 2.2. Du kan nå laste opp start- og sluttbilder, og AI beregner og genererer glatte overgangsanimasjoner mellom dem. Ingen ukontrollerbar tilfeldig morphing – du kan presist regissere hvert øyeblikk av "egg som klekker til fugl", "skisse til virkelighet" eller "kostymebytte".',
        feature2Title: '10 sekunders videoproduksjon for full historiefortelling',
        feature2Description: 'Si farvel til korte 3-sekunders klipp. Pika 2.2 dobler grensen til 10 sekunder, slik at du kan fortelle en komplett mini-historie i ett opptak, vise rikere karakterprestasjoner, mer komplekse kamerabevegelser og åpne flere muligheter for korte videoer.',
        feature3Title: 'Pikaffects kreative fysikkeffekter: alt kan lekes med',
        feature3Description: 'Pikas klassiske fysikkeffekter er enda mer realistiske i versjon 2.2. Med én kommando kan du få objekter i videoen til å bryte fysikkens lover og skape imponerende visuelle effekter. Støtter Melt, Crush, Inflate, Cake-ify og mange andre kreative effekter.',
        feature4Title: '1080p kinokvalitet med krystallklare detaljer',
        feature4Description: 'Uskarphet er ikke lenger synonymt med AI-video. Pika 2.2 støtter 1080p HD-oppløsning som standard – enten det er hårstrå, stoffteksturer eller subtile lysvariasjoner, er alt skarpt og klart for publisering på sosiale medier.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        step1Title: 'Velg Pika 2.2-modellen',
        step1Description: 'Gå til siden "AI Video Generation" og velg "Pika 2.2" i modellmenyen.',
        step2Title: 'Skriv inn dine kreative ideer',
        step2Description: 'Skriv inn en tekstbeskrivelse eller last opp bilder som referanse. Støtter Pikaframes dobbelbildeopplasting.',
        step3Title: 'Last ned videoen din',
        step3Description: 'Klikk "Create" og last ned eller del når genereringen er ferdig.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Pika 2.2',

        // X Posts section
        xPostsTitle: 'Populære X-innlegg om Pika 2.2',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre modeller',
        seedanceTitle: 'Seedance 1.0 Pro AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',

        // CTA section
        ctaTitle: 'Klar til å begynne å skape?',
        ctaDescription: 'Opplev Pika 2.2 nå og gjør kreativiteten din til fantastiske videoer',
        ctaButton: 'Begynn å skape',
        ctaDisclaimer: 'Ingen kredittkort kreves · Gratis prøveperiode for nye brukere',
    },
    nl: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI-videogenerator - Pikaframes keyframe-controle, 10-seconden 1080p HD-video',
        pageDescription: 'Ervaar Pika 2.2 van Pika Labs met revolutionaire Pikaframes keyframe-controle, die tot 10 seconden 1080p HD-video genereert. Probeer het nu op WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, keyframe-controle, AI-videogenerator, 1080p, Pikaffects, tekst naar video, afbeelding naar video, WeryAI',

        // Generator section
        generatorTitle: 'Pika AI-videogenerator (Pika Labs)',
        generatorDescription: 'WeryAI heeft het model Pika 2.2 nu diep geïntegreerd, Pika 2.2 van Pika Labs is er! Met de revolutionaire Pikaframes-technologie (keyframe-controle) ondersteunt het tot 10 seconden 1080p HD-video. Of je nu vloeiende morphing-overgangen wilt of verbluffende fysica-effecten, Pika 2.2 geeft je precieze controle over je creativiteit. Ervaar Pika 2.2 nu op WeryAI.',

        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Pika 2.2 kernfuncties',

        // Features
        feature1Title: 'Pikaframes keyframe-controle: meester over tijd en ruimte',
        feature1Description: 'Dit is de meest ingrijpende update van Pika 2.2. Je kunt nu begin- en eindframes uploaden en AI berekent en genereert vloeiende overgangen ertussen. Geen oncontroleerbare random morphing meer — je regisseert nauwkeurig elk moment van "ei dat uitkomt tot vogel", "schets naar werkelijkheid" of "kledingswissel van personage".',
        feature2Title: '10-seconden video’s voor complete storytelling',
        feature2Description: 'Zeg vaarwel tegen korte 3-seconden clips. Pika 2.2 verdubbelt de limiet naar 10 seconden. Zo kun je een complete mini-story in één shot vertellen, rijkere acteerprestaties tonen, complexere camerabewegingen gebruiken en meer mogelijkheden ontsluiten voor short-video creatie.',
        feature3Title: 'Pikaffects creatieve fysica-effecten: alles is speelbaar',
        feature3Description: 'De klassieke fysica-effecten van Pika zijn in versie 2.2 nog realistischer. Met één opdracht laat je objecten de natuurwetten tarten en spectaculaire visuals creëren. Ondersteunt Melt, Crush, Inflate, Cake-ify en veel andere creatieve effecten.',
        feature4Title: '1080p filmkwaliteit met kristalheldere details',
        feature4Description: 'Blur is niet langer synoniem met AI-video. Pika 2.2 ondersteunt 1080p HD-resolutie standaard — of het nu haarlokken, stoftexturen of subtiele lichtvariaties zijn, alles is scherp en helder en klaar voor social-media publicatie.',

        // How to use section
        howToUseTitle: 'Hoe te gebruiken',
        step1Title: 'Selecteer het Pika 2.2-model',
        step1Description: 'Ga naar de pagina "AI Video Generation" en selecteer "Pika 2.2" in het modellenmenu.',
        step2Title: 'Voer je creatieve ideeën in',
        step2Description: 'Voer een tekstbeschrijving in of upload afbeeldingen als referentie. Ondersteunt Pikaframes dual-image upload.',
        step3Title: 'Download je video',
        step3Description: 'Klik op "Create" en download of deel zodra de generatie klaar is.',

        // YouTube videos section
        youtubeTitle: 'YouTube-video’s over Pika 2.2',

        // X Posts section
        xPostsTitle: 'Populaire X-berichten over Pika 2.2',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere modellen',
        seedanceTitle: 'Seedance 1.0 Pro AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',

        // CTA section
        ctaTitle: 'Klaar om te beginnen met creëren?',
        ctaDescription: 'Ervaar Pika 2.2 nu en verander je creativiteit in geweldige video’s',
        ctaButton: 'Begin met creëren',
        ctaDisclaimer: 'Geen creditcard nodig · Gratis proefperiode voor nieuwe gebruikers',
    },
    id: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI Video Generator - Kontrol keyframe Pikaframes, video HD 1080p 10 detik',
        pageDescription: 'Rasakan Pika 2.2 terbaru dari Pika Labs dengan teknologi kontrol keyframe Pikaframes yang revolusioner, mendukung pembuatan video HD 1080p hingga 10 detik. Coba sekarang di WeryAI.',
        pageKeywords: 'Pika 2.2, Pikaframes, kontrol keyframe, generator video AI, 1080p, Pikaffects, teks ke video, gambar ke video, WeryAI',

        // Generator section
        generatorTitle: 'Pika AI Video Generator (Pika Labs)',
        generatorDescription: 'WeryAI kini telah mengintegrasikan model Pika 2.2 secara mendalam, Dengan teknologi revolusioner Pikaframes (kontrol keyframe), Pika 2.2 mendukung pembuatan video HD 1080p hingga 10 detik. Ingin transisi morphing yang halus atau efek fisika yang menakjubkan, Pika 2.2 memberi kontrol presisi pada kreativitasmu. Rasakan Pika 2.2 sekarang di WeryAI.',

        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Inti Pika 2.2',

        // Features
        feature1Title: 'Kontrol keyframe Pikaframes: menguasai waktu dan ruang',
        feature1Description: 'Ini adalah pembaruan paling revolusioner di Pika 2.2. Kini Anda dapat mengunggah frame awal dan akhir, dan AI akan menghitung serta menghasilkan animasi transisi yang halus di antara keduanya. Tidak ada lagi morphing acak yang sulit dikendalikan — Anda bisa mengarahkan setiap momen seperti "telur menetas jadi burung", "sketsa jadi nyata", atau "ganti kostum karakter".',
        feature2Title: 'Video 10 detik untuk storytelling yang utuh',
        feature2Description: 'Ucapkan selamat tinggal pada klip 3 detik yang singkat. Pika 2.2 menggandakan batas durasi menjadi 10 detik. Artinya Anda dapat menceritakan mini‑story lengkap dalam satu shot, menampilkan akting karakter yang lebih kaya, gerakan kamera yang lebih kompleks, dan membuka lebih banyak kemungkinan untuk video pendek.',
        feature3Title: 'Efek fisika kreatif Pikaffects: semuanya bisa dimainkan',
        feature3Description: 'Efek fisika klasik Pika semakin realistis di versi 2.2. Dengan satu perintah, Anda dapat membuat objek di video menentang hukum fisika dan menciptakan visual yang memukau. Mendukung Melt, Crush, Inflate, Cake-ify, dan banyak efek kreatif lainnya.',
        feature4Title: 'Kualitas sinematik 1080p dengan detail jernih',
        feature4Description: 'Blur bukan lagi sinonim video AI. Pika 2.2 mendukung resolusi HD 1080p secara native — entah helai rambut, tekstur kain, atau variasi cahaya halus, semuanya tajam dan jernih, siap untuk dipublikasikan di media sosial.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        step1Title: 'Pilih Model Pika 2.2',
        step1Description: 'Buka halaman "AI Video Generation" dan pilih "Pika 2.2" dari menu model.',
        step2Title: 'Masukkan Ide Kreatif Anda',
        step2Description: 'Masukkan deskripsi teks atau unggah gambar sebagai referensi. Mendukung unggahan dua gambar Pikaframes.',
        step3Title: 'Unduh Video Anda',
        step3Description: 'Klik "Create" dan unduh atau bagikan setelah selesai.',

        // YouTube videos section
        youtubeTitle: 'Video YouTube tentang Pika 2.2',

        // X Posts section
        xPostsTitle: 'Posting X populer tentang Pika 2.2',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi Model Lain',
        seedanceTitle: 'Generator Video AI Seedance 1.0 Pro',
        sora2Title: 'Generator Video AI OpenAI Sora-2',
        runwayTitle: 'Generator Video AI Runway',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',

        // CTA section
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription: 'Coba Pika 2.2 sekarang dan ubah kreativitasmu menjadi video yang menakjubkan',
        ctaButton: 'Mulai Berkarya',
        ctaDisclaimer: 'Tanpa kartu kredit · Uji coba gratis untuk pengguna baru',
    },
    tr: {
        // SEO Meta
        pageTitle: 'Pika 2.2 AI Video Generator - Pikaframes keyframe kontrolü, 10 saniyelik 1080p HD videolar',
        pageDescription: 'Pika Labs tarafından geliştirilen en yeni Pika 2.2 sürümünü devrim niteliğindeki Pikaframes keyframe kontrolüyle deneyimleyin; 10 saniyeye kadar 1080p HD video üretimini destekler. WeryAI’de şimdi deneyin.',
        pageKeywords: 'Pika 2.2, Pikaframes, keyframe kontrolü, AI video oluşturucu, 1080p, Pikaffects, metinden video, görüntüden video, WeryAI',

        // Generator section
        generatorTitle: 'Pika AI Video Generator (Pika Labs)',
        generatorDescription: 'WeryAI artık Pika 2.2 modelini derinlemesine entegre ediyor, Devrim niteliğindeki Pikaframes (keyframe kontrolü) teknolojisiyle 10 saniyeye kadar 1080p HD video üretimini destekler. İster akıcı morphing geçişleri ister çarpıcı fizik efektleri yaratın, Pika 2.2 yaratıcılığınızı hassas kontrolle parmaklarınızın ucuna getirir. Pika 2.2’yi şimdi WeryAI’de deneyin.',

        // Tabs
        tabImageToVideo: 'Görüntüden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Pika 2.2 Temel Özellikler',

        // Features
        feature1Title: 'Pikaframes keyframe kontrolü: zamanı ve mekânı yönetmek',
        feature1Description: 'Bu, Pika 2.2’nin en çarpıcı güncellemesidir. Artık başlangıç ve bitiş karelerini yükleyebilir, AI bu ikisi arasındaki pürüzsüz geçiş animasyonlarını hesaplayıp oluşturur. Kontrolsüz rastgele dönüşümler yok — "yumurtanın kuşa dönüşmesi", "eskizden gerçeğe" veya "karakter kostüm değişimi" gibi her anı hassas biçimde yönetebilirsiniz.',
        feature2Title: 'Tam hikâye anlatımı için 10 saniyelik video',
        feature2Description: 'Kısa 3 saniyelik kliplere veda edin. Pika 2.2, video süresi sınırını 10 saniyeye çıkarır. Bu sayede tek çekimde mini bir hikâye anlatabilir, daha zengin karakter performansları ve daha karmaşık kamera hareketleri gösterebilirsiniz.',
        feature3Title: 'Pikaffects yaratıcı fizik efektleri: her şey oynanabilir',
        feature3Description: 'Pika’nın klasik fizik efektleri 2.2 sürümünde daha gerçekçi hale geldi. Tek bir komutla videodaki nesneleri fizik kurallarını aşacak şekilde hareket ettirip çarpıcı görseller oluşturabilirsiniz. Melt, Crush, Inflate, Cake-ify ve daha birçok yaratıcı efekti destekler.',
        feature4Title: 'Kristal netlikte 1080p sinema kalitesi',
        feature4Description: 'Bulanıklık artık AI videonun eş anlamlısı değil. Pika 2.2, 1080p HD çözünürlüğü yerel olarak destekler — saç telleri, kumaş dokuları veya ince ışık geçişleri olsun, her şey net ve keskindir, sosyal medya yayın standardına hazırdır.',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        step1Title: 'Pika 2.2 modelini seçin',
        step1Description: '"AI Video Generation" sayfasına gidin ve model açılır menüsünden "Pika 2.2"yi seçin.',
        step2Title: 'Yaratıcı fikrinizi girin',
        step2Description: 'Metin açıklaması girin veya referans için görsel yükleyin. Pikaframes çift görsel yüklemeyi destekler.',
        step3Title: 'Videonuzu indirin',
        step3Description: '"Create"e tıklayın ve üretim tamamlanınca indirin veya paylaşın.',

        // YouTube videos section
        youtubeTitle: 'Pika 2.2 hakkında YouTube videoları',

        // X Posts section
        xPostsTitle: 'Pika 2.2 hakkında popüler X paylaşımları',

        // Explore other models section
        exploreModelsTitle: 'Diğer Modelleri Keşfedin',
        seedanceTitle: 'Seedance 1.0 Pro AI Video Oluşturucu',
        sora2Title: 'OpenAI Sora-2 AI Video Oluşturucu',
        runwayTitle: 'Runway AI Video Oluşturucu',

        // FAQ section
        faqTitle: 'Sık Sorulan Sorular',

        // CTA section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription: 'Pika 2.2’yi şimdi deneyin ve yaratıcılığınızı harika videolara dönüştürün',
        ctaButton: 'Oluşturmaya Başla',
        ctaDisclaimer: 'Kredi kartı gerekmez · Yeni kullanıcılar için ücretsiz deneme',
    },
}
